import { agentColors } from './agentChatLayout'

/** Friendly model label + color for hero card. */
export function formatAgentModel(llm) {
  if (!llm) {
    return { label: 'Loading…', color: agentColors.textMuted, configured: false }
  }
  if (llm.configured === false) {
    return { label: 'Not configured', color: agentColors.textMuted, configured: false }
  }
  return {
    label: llm.display_name || llm.model || 'Unknown',
    color: agentColors.textPrimary,
    configured: true,
    provider: llm.provider,
    model: llm.model,
  }
}
